const BRANDING_URL_PATH_MARKER = '/signage/logos';
/**
 * Rewrites a branding URL so the logo is served from the current origin
 * (CloudFront proxy) instead of the raw upstream host (e.g. S3).
 *
 * The backend returns absolute URLs such as
 * `https://s3.../signage/logos/<id>/logo/<file>.png`, but the logo is proxied
 * at the kiosk's own origin under `/signage/logos/...`. When the marker is
 * present we replace everything before it with `window.origin`; otherwise the
 * URL is returned unchanged.
 */
export const resolveBrandingUrl = (brandingUrl) => {
    if (!brandingUrl) {
        return undefined;
    }
    const markerIndex = brandingUrl.indexOf(BRANDING_URL_PATH_MARKER);
    if (markerIndex === -1 || typeof window === 'undefined') {
        return brandingUrl;
    }
    return `${window.origin}${brandingUrl.slice(markerIndex)}`;
};
